import * as React from 'react';

export function IconExcel() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" fill="none" viewBox="0 0 20 20">
      <path
        fill="#fff"
        d="M14.429 1.563H5.937a.625.625 0 00-.625.625v15.624a.625.625 0 00.625.625h11.875a.624.624 0 00.625-.625V5.572a.625.625 0 00-.183-.443l-3.383-3.383a.625.625 0 00-.442-.183z"
      />
      <path fill="#fff" d="M14.375 1.875V5a.625.625 0 00.625.625h3.125" />
      <path stroke="#152242" strokeMiterlimit="10" strokeOpacity=".4" d="M14.375 1.875V5a.625.625 0 00.625.625h3.125" />
      <path
        fill="#152242"
        fillOpacity=".4"
        d="M16.563 9.375h-3.125a.313.313 0 110-.625h3.124a.313.313 0 110 .625zm0 1.25h-3.125a.313.313 0 110-.625h3.124a.313.313 0 110 .625zm0 1.25h-3.125a.313.313 0 110-.625h3.124a.313.313 0 110 .625zm0 1.25h-3.125a.313.313 0 110-.625h3.124a.313.313 0 110 .625zm0 1.25h-3.125a.313.313 0 110-.625h3.124a.313.313 0 110 .625zm-4.375-5h-2.5a.312.312 0 110-.625h2.5a.313.313 0 110 .625zm0 1.25h-2.5a.312.312 0 110-.625h2.5a.313.313 0 110 .625zm0 1.25h-2.5a.312.312 0 110-.625h2.5a.313.313 0 110 .625zm0 1.25h-2.5a.312.312 0 110-.625h2.5a.313.313 0 110 .625zm0 1.25h-2.5a.312.312 0 110-.625h2.5a.313.313 0 110 .625z"
      />
      <path
        fill="#107C41"
        d="M2.188 15.625h6.874a.938.938 0 00.938-.938V7.814a.937.937 0 00-.938-.938H2.189a.937.937 0 00-.938.938v6.875a.937.937 0 00.938.937z"
      />
      <path
        fill="#F9F7F7"
        d="M3.75 13.75l1.359-2.506L3.864 8.75h1.001l.68 1.593c.062.151.105.264.128.339h.01c.044-.121.09-.239.14-.353l.726-1.579h.918l-1.276 2.48L7.5 13.75h-.978L5.737 12a1.603 1.603 0 01-.093-.234h-.011a1.207 1.207 0 01-.091.226l-.808 1.758H3.75z"
      />
    </svg>
  );
}
